<script setup>
import router from '@/router';
import { defineProps } from 'vue'
const props = defineProps({
  title: {
    type: String,
    default: '列表'
  }
})
const back = () => {
  router.go(-1)
}
</script>

<template>
  <div class="header">
    <!-- <el-page-header style="margin-top: 10px;"
      icontext="返回" title="列表" subtitle="" @back="back"/> -->
    <el-page-header @back="back" :title="title">
      <template #content>
        <span style="font-size: 15px;"> 
          {{ router.currentRoute.value.meta.title }} 
          <!-- 这两个都可以 -->
          <!-- {{ $route.meta.title }} -->
        </span>
      </template>
    </el-page-header>
  </div>
</template>

<style scoped>
.header{
  /* background: #fff; */
  /* border-bottom: 1px solid #e6e3e3; */
  padding-bottom: 5px;
  padding-left: 15px;
  margin-top: 8px;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 999;
}
</style>
